import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CircleAlert, LucideAngularModule } from 'lucide-angular';
import { ErrorMessagePipe } from '@app/shared/error-message.pipe';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  imports: [ReactiveFormsModule, LucideAngularModule, ErrorMessagePipe],
  styleUrls: ['./textarea.component.css'],
  standalone: true,
})
export class TextareaComponent {
  @Input() control!: FormControl;
  @Input() name = '';
  @Input() placeholder = '';
  @Input() label = '';
  @Input() rows = 3;

  protected readonly Validators = Validators;
  protected readonly CircleAlert = CircleAlert;
  protected readonly Object = Object;
}
